const SPEEDCURVE_LABEL_RESOURCE_PAGE = 'Resource';
const SPEEDCURVE_LABEL_HOMEPAGE = 'Homepage';
const SPEEDCURVE_LABEL_EDX_COURSE_ABOUT = 'Course About edX';
const SPEEDCURVE_LABEL_SCHOOL_ABOUT = 'School About';
const SPEEDCURVE_LABEL_EDX_PROGRAM_ABOUT = 'Program About edX';
const SPEEDCURVE_LABEL_MASTERS_ABOUT = 'Masters About';
const SPEEDCURVE_LABEL_INSTRUCTOR_BIO = 'Instructor Bio';
const SPEEDCURVE_LABEL_CONTAINER = 'PLI Container Page';
const SPEEDCURVE_LABEL_PRODUCT_LANDING = 'Product Landing Page';
const SPEEDCURVE_LABEL_SUBCATEGORY = 'Subcategory Page';
const SPEEDCURVE_LABEL_LEARN_PAGE = 'Learn Page';
const SPEEDCURVE_LABEL_LEARN_TOPIC = 'Topic Learn Page';
const SPEEDCURVE_LABEL_LEARN_MODULAR = 'Modular Learn Page';
const SPEEDCURVE_LABEL_MODULAR_PAGE = 'Modular Page';
const SPEEDCURVE_LABEL_BOOTCAMP_PAGE = 'Bootcamp Page';
const SPEEDCURVE_LABEL_DEGREE_PAGE = 'Degree Page';
const SPEEDCURVE_LABEL_STOREFRONT_PRODUCT_PAGE = 'Product Page';

const SPEEDCURVE_PLI_PAGES = {
  '/xseries': SPEEDCURVE_LABEL_CONTAINER,
  '/doctorate': SPEEDCURVE_LABEL_CONTAINER,
  '/micromasters': SPEEDCURVE_LABEL_CONTAINER,
  '/certificates': SPEEDCURVE_LABEL_CONTAINER,
  '/masters': SPEEDCURVE_LABEL_CONTAINER,
  '/bachelors': SPEEDCURVE_LABEL_CONTAINER,
  '/executive-education': SPEEDCURVE_LABEL_CONTAINER,
  '/become': SPEEDCURVE_LABEL_CONTAINER,
};

export {
  SPEEDCURVE_LABEL_RESOURCE_PAGE,
  SPEEDCURVE_LABEL_HOMEPAGE,
  SPEEDCURVE_LABEL_EDX_COURSE_ABOUT,
  SPEEDCURVE_LABEL_SCHOOL_ABOUT,
  SPEEDCURVE_LABEL_EDX_PROGRAM_ABOUT,
  SPEEDCURVE_LABEL_MASTERS_ABOUT,
  SPEEDCURVE_LABEL_INSTRUCTOR_BIO,
  SPEEDCURVE_LABEL_CONTAINER,
  SPEEDCURVE_LABEL_PRODUCT_LANDING,
  SPEEDCURVE_LABEL_SUBCATEGORY,
  SPEEDCURVE_LABEL_LEARN_PAGE,
  SPEEDCURVE_LABEL_LEARN_TOPIC,
  SPEEDCURVE_LABEL_LEARN_MODULAR,
  SPEEDCURVE_LABEL_MODULAR_PAGE,
  SPEEDCURVE_PLI_PAGES,
  SPEEDCURVE_LABEL_BOOTCAMP_PAGE,
  SPEEDCURVE_LABEL_DEGREE_PAGE,
  SPEEDCURVE_LABEL_STOREFRONT_PRODUCT_PAGE,
};
